import { jwtDecode } from "jwt-decode";

export const checkTokenExpiration = () => {
  const localStorageToken = localStorage.getItem("token");
  const customer_id = localStorage.getItem("customer_id");
  if (localStorageToken && customer_id) {
    try {
      const decoded = jwtDecode(localStorageToken);
      const now = Date.now() / 1000;

      if (decoded.exp && now > decoded.exp) {
        localStorage.clear();
        return false;
      }
      return true;
    } catch (error) {
      console.error("Invalid token:", error);
      localStorage.clear();
      return false;
    }
  }

  return false;
};
